import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import { m } from 'framer-motion';

interface CustomButtonProps {
  enabled: boolean;
}

export const CustomButton = styled(Button)<CustomButtonProps>(({ enabled }) => ({
  pointerEvents: enabled ? 'auto' : 'none',
  opacity: enabled ? 1 : 0.5,
  display: 'flex',
  maxWidth: '15rem',
  alignItems: 'center',
  justifyContent: 'flex-start',
  color: '#fff',
  borderColor: 'transparent',
  padding: '0.5rem 1rem',
  textTransform: 'none',
  fontSize: '1.05rem',
  borderRadius: '2rem',
  backgroundColor: 'transparent',
  transition: 'transform 0.2s ease-in-out, border 0.2s ease-in-out',
  '&:hover': {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
  },
}));

export const IconWrapper = styled('div')({
  width: '3rem',
  height: '3rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: '1px solid #fff',
  marginRight: '0.5rem',
  '@media (max-width: 620px)': {
    width: '2.5rem',
    height: '2.5rem',
  },
});

export const ButtonText = styled('span')({
  marginLeft: '0.5rem',
  '@media (max-width: 620px)': {
    fontSize: '0.9rem',
  },
});